import {RestApiService} from '../../../rest-api.service';
import {ApiV0} from '../../api.v0';
import {Observable} from 'rxjs';
import {BaseCollectionModel} from '@yasc/yasc-material-components';
import {BankAccountRes} from '../../../../contracts/v0/cp/bank.contract';

export class ApiV0BankAccount{
    segment = '/bankAccounts'
    constructor(v0:ApiV0, private rest:RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    fullDetails(): Observable<BaseCollectionModel<BankAccountRes>> {
        return this.rest.get<BaseCollectionModel<BankAccountRes>>(this.segment, BankAccountRes);
    }

    delete(ids:string[]) {
        return this.rest.delete<void>(this.segment, {}, ids);
    }
}